export default (props, errorProp = 'helperText') => {
    const { meta: { touched, error, warning } = {} } = props;
    return touched && (error || warning) ? { error: !!(error || warning), [errorProp]: error } : {};
};
